<template>
  <div class="view-type" :class="[menu ? 'opened-menu-top' : '']">
    <v-layout>
      <v-flex xs6 class="px-1">
        <v-toolbar class="toolbars" height="40px">
          <mf-toggle v-model="actives" class="mt-3 pt-2" color="verde-l10" value="ativos" @change="changeToggle('ativos')" />
          <v-divider vertical class="pl-2" />
          <span class="mx-3 primary-text map-filters">Ativos</span>
          <!-- <data-detalhes-menu title="Ativos" @click.native.stop :data.sync="ativosData" :data-inicial.sync="ativosDataInicial" :data-final.sync="ativosDataFinal" @filtrar="$emit('filtrarAtivos')" /> -->
        </v-toolbar>
      </v-flex>
      <v-flex xs6 class="px-1">
        <v-toolbar class="inativos-toolbar toolbars" height="40px">
          <mf-toggle v-model="inactives" class="mt-3 pt-2" color="vermelho-0" value="inativos" @change="changeToggle('inativos')" />
          <v-divider vertical class="pl-2" />
          <span class="mx-3 primary-text map-filters">Inativos recentes</span>
          <v-tooltip bottom class="secondary-text">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <mf-icon small color="cinza-0">help</mf-icon>
              </span>
            </template>
            <span>Clientes que compraram no mês retrasado mas não no passado</span>
          </v-tooltip>
          <!-- <data-detalhes-menu title="Inativos recentes" @click.native.stop :data.sync="inativosData" :data-inicial.sync="inativosDataInicial" :data-final.sync="inativosDataFinal" @filtrar="$emit('filtrarInativos')" /> -->
        </v-toolbar>
      </v-flex>

      <v-btn
        :ripple="false"
        :icon="menu"
        color="grey lighten-4"
        class="mt-0 open-button"
        :class="[menu ? 'button-shadow' : '']"
        @click="$emit('update:menu', !menu)"
      >
        <mf-icon v-if="menu" color="black">keyboard_arrow_right</mf-icon>
        <mf-icon v-else color="black">keyboard_arrow_left</mf-icon>
        <span v-if="!menu">Filtros</span>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
// import DataDetalhesMenu from '@/modules/clientes/mapa/views/pages/DataDetalhesMenu.vue'

export default {
  // components: {
  //   DataDetalhesMenu
  // },
  props: {
    menu: Boolean,
    dataAtivos: [String, Array],
    dataInativos: [String, Array],
    toggleOptions: Array,
  },
  data: () => ({
    ativosDataInicial: null,
    ativosDataFinal: null,
    inativosDataInicial: null,
    inativosDataFinal: null,
    actives: true,
    inactives: true,
  }),
  computed: {
    ativosData: {
      get() {
        return this.dataAtivos
      },
      set(value) {
        this.$emit('update:dataAtivos', value)
      },
    },
    inativosData: {
      get() {
        return this.dataInativos
      },
      set(value) {
        this.$emit('update:dataInativos', value)
      },
    },
    toggleComputed: {
      get() {
        return this.toggleOptions
      },
      set(value) {
        this.$emit('update:toggleOptions', value)
      },
    },
  },
  methods: {
    changeToggle(field) {
      const toggles = cloneDeep(this.toggleComputed)
      if (this.toggleComputed.includes(field)) {
        const index = this.toggleComputed.findIndex((item) => item === field)
        toggles.splice(index, 1)
        this.toggleComputed = toggles
      } else {
        toggles.push(field)
        this.toggleComputed = toggles
      }

      this.$emit('toggle')
    },
  },
}
</script>

<style lang="scss" scoped>
.view-type {
  position: absolute;
  right: 0;
  z-index: 12;
  margin-top: 20px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  .v-text-field--box .v-input__slot,
  .v-text-field--outline .v-input__slot {
    min-height: 40px !important;
  }
  .v-input__append-inner {
    margin-top: 0;
  }
  .v-text-field__details {
    margin: 0 !important;
  }
  .inativos-toolbar {
    width: 250px !important;
    min-width: 250px !important;
  }
  .open-button {
    height: 40px !important;
    margin-right: 0 !important;
    border-radius: 20px 0 0 20px !important;
  }
  .button-shadow {
    box-shadow: 0 1.6px 4px $cinza-d10 !important;
    background-color: $branco;
  }
  .map-filters {
    white-space: nowrap;
  }
  &.opened-menu-top {
    .inativos-toolbar {
      margin-right: 65px;
    }
  }
}
</style>
